// Uploady
import { ChunkedUploady } from '@rpldy/chunked-uploady'
import { retryEnhancer } from '@rpldy/retry-hooks'
import { UploadDropZone } from '@rpldy/upload-drop-zone'

// Interfaces
import { IWrapperProps } from './interfaces'

const Wrapper = ({ children, ...rest }: IWrapperProps) => {
  return (
    <ChunkedUploady
      {...rest}
      maxConcurrent={rest?.maxConcurrent ? rest?.maxConcurrent : 1}
      concurrent={rest?.concurrent ? rest?.concurrent : true}
      enhancer={retryEnhancer}
      chunked={false}
    >
      <UploadDropZone onDragOverClassName="drag-over">{children}</UploadDropZone>
    </ChunkedUploady>
  )
}

export { Wrapper }
